import React from "react";
import { ReactComponent as DeleteFile } from "../assets/images/icons/delete-small.svg";

/**
 * Small tag/chip - value plus an optional remove control. Mirrors the
 * multi-value chip look already used by DataMappingMultiSelect's
 * react-select styling (light grey pill, dark text), as a plain
 * component for places that aren't a select input (patient ID tags,
 * CIOMS case tags).
 */
const Chip = ({ children, onRemove, className = "" }) => (
  <span className={`chip ${className}`}>
    <span className="chip__label">{children}</span>
    {onRemove && (
      <button
        type="button"
        className="chip__remove"
        onClick={onRemove}
        aria-label="Remove">
        <DeleteFile />
      </button>
    )}
  </span>
);

export default Chip;
